import { render, staticRenderFns } from "./DesignLayout.vue?vue&type=template&id=b4dccf80&scoped=true&"
import script from "./DesignLayout.vue?vue&type=script&lang=ts&"
export * from "./DesignLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DesignLayout.vue?vue&type=style&index=0&id=b4dccf80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dccf80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VFabTransition,VRow})
